export enum ReceiverType {
    VEHICLE = 'VEHICLE',
    LINE = 'LINE',
    ALL = 'ALL'
}
